import { useState } from 'react';

import { useQuery } from '@apollo/client';
import { Box, ContentLayoutF, Heading, Separator } from '@betterment/samba-react';
import { ErrorBoundary } from '@betterment/shared-components';

import { AccountsCard } from './components/accounts-card/AccountsCard';
import { ArticlesCard } from './components/articles-card/ArticlesCard';
import { Balance } from './components/balance/Balance';
import { DividendsAndInterestCard } from './components/dividends-and-interest-card/DividendsAndInterestCard';
import { TaxSavingsCard } from './components/tax-savings-card/TaxSavingsCard';
import { PerformanceAccountsDocument } from './graphql/performanceAccounts.generated';

import { DateRangeOption } from '../../graphql/schema';
import { ApplicationLayout } from '../../Shared/layout/ApplicationLayout';
import { DateRangeFilter } from '../shared/date-range-filter/DateRangeFilter';

export const UserPerformancePage: React.FC = () => {
  const [dateRangeOption, setDateRangeOption] = useState<DateRangeOption>(DateRangeOption.AllTime);

  const { data } = useQuery(PerformanceAccountsDocument, {
    variables: { dateRangeOption },
  });

  return (
    <ErrorBoundary fallbackType="full" feature="performance_page" owner="user_engagement">
      <ApplicationLayout pageTitle="Performance" feature="performance_page">
        <ApplicationLayout.Header>
          <Box css={{ paddingY: 'space.300' }}>
            <Heading variant="title400">Performance</Heading>
            <Separator css={{ fullWidthWithInset: 'space.0', marginTop: 'space.300', marginBottom: 'space.400' }} />
            <DateRangeFilter onChange={setDateRangeOption} selected={dateRangeOption} />
          </Box>
        </ApplicationLayout.Header>
        <ApplicationLayout.Content>
          <ContentLayoutF>
            <ContentLayoutF.SlotContainer css={{ paddingTop: 'space.400' }}>
              <ContentLayoutF.Slot1
                css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
              >
                {data && (
                  <>
                    <Balance dateRangeOption={dateRangeOption} accounts={data.performance.accounts} />
                    <AccountsCard accounts={data.performance.accounts} />
                  </>
                )}
              </ContentLayoutF.Slot1>
              <ContentLayoutF.Slot2
                css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
              >
                <DividendsAndInterestCard dateRangeOption={dateRangeOption} />
                <TaxSavingsCard dateRangeOption={dateRangeOption} />
                <ArticlesCard />
              </ContentLayoutF.Slot2>
            </ContentLayoutF.SlotContainer>
          </ContentLayoutF>
        </ApplicationLayout.Content>
      </ApplicationLayout>
    </ErrorBoundary>
  );
};
